import { type ReactNode } from 'react';

const SHAPE = 'animate-pulse rounded-md bg-white/[0.04]';

function ProfileRow(): ReactNode {
  return (
    <div className="flex items-center gap-md">
      <div className={`h-10 w-10 shrink-0 rounded-full ${SHAPE}`} />
      <div className="space-y-1.5">
        <div className={`h-3 w-32 ${SHAPE}`} />
        <div className={`h-2.5 w-44 ${SHAPE}`} />
      </div>
    </div>
  );
}

function FieldsBlock(): ReactNode {
  return (
    <div className="grid grid-cols-2 gap-base border-t border-white/[0.06] pt-base">
      <div className={`h-12 ${SHAPE}`} />
      <div className={`h-12 ${SHAPE}`} />
    </div>
  );
}

function OverrideBlock(): ReactNode {
  return (
    <div className="space-y-sm border-t border-white/[0.06] pt-base">
      <div className={`h-2.5 w-20 ${SHAPE}`} />
      <div className={`h-24 ${SHAPE}`} />
    </div>
  );
}

function FooterRow(): ReactNode {
  return (
    <div className="flex items-center justify-end gap-md pt-sm">
      <div className={`h-3 w-24 ${SHAPE}`} />
      <div className={`h-3 w-12 ${SHAPE}`} />
      <div className={`h-3 w-16 ${SHAPE}`} />
    </div>
  );
}

export function ApproacherDetailSkeleton(): ReactNode {
  return (
    <div className="space-y-base">
      <ProfileRow />
      <FieldsBlock />
      <OverrideBlock />
      <FooterRow />
    </div>
  );
}
